import React from 'react';
import { Box, Typography } from '@mui/material';
import { usePartnerReferralDetailsStyles } from '../styles';
import { DateObject } from '@uplift/services';

export type ReferralDetailsSectionProps = {
  referralDate: DateObject;
  subtitle?: string;
};

export const ReferralDetailsSection: React.VFC<ReferralDetailsSectionProps> = ({
  referralDate,
  subtitle
}) => {
  const { classes } = usePartnerReferralDetailsStyles();

  return (
    <Box display="flex" flexDirection="column" gap="8px">
      <Typography variant="overline" className={classes.subTitle}>
        Details
      </Typography>
      <Typography variant="body2" color="textPrimary" data-testid="referral-date">
        {`Date: ${referralDate.format(
          'MM/DD/YYYY'
        )}`}
      </Typography>
      <Typography variant="body2" color="textPrimary" data-testid="referral-sent">
        {`Sent: ${referralDate.format(
          'hh:mm A'
        )} ES`}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          color="textPrimary"
          data-testid="referral-from-org"
        >{subtitle}</Typography>
      )}
    </Box>
  );
};
